/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SalesTaxRatesRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { SlicedDataSource } from '@gh/core-data';
import { SalesTaxRateListItem } from './sales-rate-rate.model';

export type SalesTaxRateFinderDialogConfig = FinderDialogConfig;

@Injectable()
export class SalesTaxRateFinderBusinessService {
  constructor(private salesTaxRateRest: SalesTaxRatesRestService) {

  }

  findAllAsDataSource(): SlicedDataSource<SalesTaxRateListItem> {
    return this.salesTaxRateRest.findAllAsDataSource();
  }
}
